export default [
    { _id : 0, title : 'Home', url : '/', active : true },
    { _id : 1, title : 'About', url : '/about', active : true },
    { _id : 2, title : 'Work', url : '/work', active : true },
    { _id : 3, title : 'Contact', url : '/contact', active : true },
]